// extracted by mini-css-extract-plugin
export default {"dialog":"ProductDialog_dialog__h7A+7","wrapper":"ProductDialog_wrapper__25Tht","productsCaption":"ProductDialog_productsCaption__DdsSo"};